import { Component } from '@angular/core';
import { IhmLoadingIndicatorService } from '../../shared/services/ihm-loading-indicator.service';

@Component({
  selector: 'ihm-loading-indicator',
  templateUrl: './ihm-loading-indicator.component.html',
  styleUrls: ['./ihm-loading-indicator.component.scss']
})
export class IhmLoadingIndicatorComponent {
  public isShown = false;

  constructor(private ihmLoadingIndicatorService: IhmLoadingIndicatorService) {
    this.ihmLoadingIndicatorService.onToggle.subscribe(
      (updatedState: boolean) => (this.isShown = updatedState),
      (err: Error) => console.error(err)
    );
  }
}
